import { type FunctionWorkflowNode, type Workflow } from '@blaze-shared/workflow-domain';

import { OUTPUT_VARIABLES_SOURCE_ID } from '../../errors';
import {
  OrphanedFunctionOutputWorkflowError,
  type WorkflowError,
} from '../../errors/workflow-error';

/**
 * Flags ExecuteWorkflow (function call) nodes whose outputVariables still map
 * function output ids that no longer exist on the function definition (BL-10722).
 */
export function validateOrphanedFunctionOutputVariables(
  workflowId: string,
  node: FunctionWorkflowNode,
  workflows: Workflow[],
): WorkflowError<any>[] {
  const assignments = node.outputVariables ?? {};
  if (!Object.keys(assignments).length) {
    return [];
  }

  const fnWorkflow = workflows.find((wf) => wf.id === node.workflowId);
  if (fnWorkflow?.workflowType !== 'Function') {
    return [];
  }

  const fnOutputIds = new Set(
    (fnWorkflow.outputVariables ?? []).map(({ variableId }) => variableId),
  );
  const orphanedVariableIds = Object.entries(assignments)
    .filter(([variableId, name]) => !fnOutputIds.has(variableId) && !!name?.trim())
    .map(([variableId]) => variableId);

  if (!orphanedVariableIds.length) {
    return [];
  }

  return [
    new OrphanedFunctionOutputWorkflowError(
      workflowId,
      node.id,
      orphanedVariableIds,
      OUTPUT_VARIABLES_SOURCE_ID,
    ),
  ];
}
